module.exports = __webpack_public_path__ + "img/up.1473a412.png";